<template>
    <div>
        <table class="w-full border">
            <thead>
                <tr>
                    <th colspan="4" class="text-center border-gray border-r-2">Source</th>
                    <th colspan="4" class="text-center border-gray border-r-2 border-l-2">Friend</th>
                    <th class="border-b-0"></th>
                </tr>
                <tr>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-gray py-2 px-2" sort-by="source_first_name">First Name</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-gray py-2 px-2" sort-by="source_last_name">Last Name</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-gray py-2 px-2" sort-by="source_email">Email</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-r-2 border-gray py-2 px-2" sort-by="source_promo_code">Promo Code</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-l-2 border-gray py-2 px-2" sort-by="friend_first_name">First Name</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-gray py-2 px-2" sort-by="friend_last_name">Last Name</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-gray py-2 px-2" sort-by="friend_email">Email</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-t-2 border-gray py-2 px-2" sort-by="friend_promo_code">Promo Code</sortable-header>
                    <sortable-header @sort="handleSort" :direction="sort_direction" :column="sort_column" class="text-center border-b-2 border-l-2 border-gray py-2 px-2" sort-by="created_at">Created On</sortable-header>
                </tr>
            </thead>
            <tbody>
                <tr v-for="referral in data.referrals" :key="referral.id">
                    <td class="px-2 py-2">{{ referral.source_first_name }}</td>
                    <td class="px-2 py-2">{{ referral.source_last_name }}</td>
                    <td class="px-2 py-2">{{ referral.source_email }}</td>
                    <td class="border-r-2 px-2 py-2" :style="referral.source_promo_used === 1 ? 'background-color: #b0f1b0' : ''">{{ referral.source_promo_code }}</td>
                    <td class="border-l-2 px-2 py-2">{{ referral.friend_first_name }}</td>
                    <td class="px-2 py-2">{{ referral.friend_last_name }}</td>
                    <td class="px-2 py-2">{{ referral.friend_email }}</td>
                    <td class="border-r-2 px-2 py-2" :style="referral.friend_promo_used === 1 ? 'background-color: #b0f1b0' : ''">{{ referral.friend_promo_code }}</td>
                    <td class="border-l-2 px-2 py-2 text-right">{{ formatTimestamp(referral.created_at) }}</td>
                </tr>
            </tbody>
        </table>

        <div class="flex justify-start my-2">
            <div class="flex flex-col text-left">
                <div class="px-4 mb-1">Referrals:</div>
                <div class="px-4 mb-1">Source Promos Used:</div>
                <div class="px-4 mb-1">Friend Promos Used:</div>
            </div>
            <div class="flex flex-col text-right">
                <div class="font-bold mb-1">{{ data.referrals.length }}</div>
                <div class="font-bold mb-1">{{ data.source_promo_used }}</div>
                <div class="font-bold mb-1">{{ data.friend_promo_used }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import SortableHeader from '@/Shared/SortableHeader';
import { DateTime } from "luxon";

export default {
    name: 'ReferralCampaign',

    components: {
        SortableHeader,
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort(sort) {
            this.$emit('sort', sort, 'referrals');
        },

        formatTimestamp(timestamp) {
            return DateTime.fromSQL(timestamp).toFormat('MMM. d, yyyy h:mm a');
        },
    },
}
</script>